function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "22",
  viewBox: "8 2 32 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.501 4.579c1.15-2.021 4.063-2.021 5.214 0L38.97 26.1c1.139 2-.306 4.485-2.607 4.485h-24.51c-2.3 0-3.745-2.485-2.606-4.485L21.5 4.58z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.108 12.522v6.956",
  stroke: "#F6335D",
  strokeWidth: "3",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "24.108",
  cy: "25.166",
  r: "2.182",
  fill: "#F6335D"
})));